import { isNullOrUndefined, attributes } from '@syncfusion/ej2-base';
import { iterateArrayOrObject } from '../base/util';
import { CellType } from '../base/enum';
/**
 * `CellMergeRender` module.
 *
 * @hidden
 */
export class CellMergeRender {
    constructor(serviceLocator, parent) {
        this.serviceLocator = serviceLocator;
        this.parent = parent;
    }
    render(cellArgs, row, i, td) {
        const cellRendererFact = this.serviceLocator.getService('cellRendererFactory');
        const cellRenderer = cellRendererFact.getCellRenderer(row.cells[parseInt(i.toString(), 10)].cellType
            || CellType.Data);
        let colSpan = row.cells[parseInt(i.toString(), 10)].cellSpan ? row.cells[parseInt(i.toString(), 10)].cellSpan :
            cellArgs.colSpan ? (cellArgs.colSpan + i) <= row.cells.length ? cellArgs.colSpan : row.cells.length - i : 1;
        const rowSpan = cellArgs.rowSpan;
        let visible = 0;
        let spannedCell;
        if (row.index > this.parent.pinnedTopRecords.length) {
            const index = row.index - this.parent.pinnedTopRecords.length;
            const rowsObject = this.parent.getRowsObject().filter((row) => row.isDataRow);
            const cells = this.parent.groupSettings.columns.length > 0
                && !rowsObject[parseInt(index.toString(), 10) - 1].isDataRow
                ? rowsObject[parseInt(index.toString(), 10)].cells : rowsObject[parseInt(index.toString(), 10) - 1].cells;
            const targetCell = row.cells[parseInt(i.toString(), 10)];
            const uid = 'uid';
            spannedCell = cells.filter((cell) => cell.column.uid === targetCell.column[`${uid}`])[0];
        }
        const colSpanLen = spannedCell && spannedCell.colSpanRange > 1 && spannedCell.rowSpanRange > 1 ?
            spannedCell.colSpanRange : colSpan;
        for (let j = i + 1; j < i + colSpanLen && j < row.cells.length; j++) {
            if (row.cells[parseInt(j.toString(), 10)].visible === false) {
                visible++;
            }
            else {
                row.cells[parseInt(j.toString(), 10)].isSpanned = true;
            }
        }
        if (visible > 0) {
            for (let j = i + colSpan; j < i + colSpan + visible && j < row.cells.length; j++) {
                row.cells[parseInt(j.toString(), 10)].isSpanned = true;
            }
            if (i + colSpan + visible >= row.cells.length) {
                colSpan -= (i + colSpan + visible) - row.cells.length;
            }
        }
        if (row.cells[parseInt(i.toString(), 10)].cellSpan) {
            row.data[cellArgs.column.field] = row.cells[parseInt(i.toString(), 10)].spanText;
            const index = row.index - this.parent.pinnedTopRecords.length;
            td = cellRenderer.render(row.cells[parseInt(i.toString(), 10)], row.data, { 'index': !isNullOrUndefined(index) ? index.toString() : '' });
        }
        if (colSpan > 1) {
            attributes(td, { 'colSpan': colSpan.toString(), 'aria-colSpan': colSpan.toString() });
        }
        if (rowSpan > 1) {
            attributes(td, { 'rowspan': rowSpan.toString(), 'aria-rowspan': rowSpan.toString() });
            row.cells[parseInt(i.toString(), 10)].isRowSpanned = true;
            row.cells[parseInt(i.toString(), 10)].rowSpanRange = Number(rowSpan);
            if (colSpan > 1) {
                row.cells[parseInt(i.toString(), 10)].colSpanRange = Number(colSpan);
            }
        }
        if (row.index > this.parent.pinnedTopRecords.length && (spannedCell.rowSpanRange > 1)) {
            row.cells[parseInt(i.toString(), 10)].isSpanned = true;
            row.cells[parseInt(i.toString(), 10)].rowSpanRange = Number(spannedCell.rowSpanRange - 1);
            row.cells[parseInt(i.toString(), 10)].colSpanRange = spannedCell.rowSpanRange > 0 ? spannedCell.colSpanRange : 1;
        }
        if (this.parent.enableColumnVirtualization && !row.cells[parseInt(i.toString(), 10)].cellSpan &&
            !this.containsKey(cellArgs.column.field, cellArgs.data[cellArgs.column.field])) {
            this.backupMergeCells(cellArgs.column.field, cellArgs.data[cellArgs.column.field], cellArgs.colSpan);
        }
        return td;
    }
    backupMergeCells(fName, data, span) {
        this.setMergeCells(this.generteKey(fName, data), span);
    }
    generteKey(fname, data) {
        return fname + '__' + data.toString();
    }
    splitKey(key) {
        return key.split('__');
    }
    containsKey(fname, data) {
        // eslint-disable-next-line no-prototype-builtins
        return this.getMergeCells().hasOwnProperty(this.generteKey(fname, data));
    }
    getMergeCells() {
        return this.parent.mergeCells;
    }
    setMergeCells(key, span) {
        this.parent.mergeCells[`${key}`] = span;
    }
    updateVirtualCells(rows) {
        const mCells = this.getMergeCells();
        for (const key of Object.keys(mCells)) {
            const value = mCells[`${key}`];
            const merge = this.splitKey(key);
            const columnIndex = this.getIndexFromAllColumns(merge[0]);
            const vColumnIndices = this.parent.getColumnIndexesInView();
            const span = value - (vColumnIndices[0] - columnIndex);
            if (columnIndex < vColumnIndices[0] && span > 1) {
                for (const row of rows) {
                    if (row.data[merge[0]].toString() === merge[1].toString()) {
                        row.cells[0].cellSpan = span;
                        row.cells[0].spanText = merge[1];
                        break;
                    }
                }
            }
        }
        return rows;
    }
    getIndexFromAllColumns(field) {
        const index = iterateArrayOrObject(this.parent.getVisibleColumns(), (item, index) => {
            if (item.field === field) {
                return index;
            }
            return undefined;
        })[0];
        return index;
    }
}
